import React from "react";
import "./Skills.css";
import Android from "./Android";
import CrossPlatform from "./CrossPlatform";
import MachineLearning from "./MachineLearning";
import Languages from "./Languages";
import Others from "./Others";
import UxUi from "./UxUi";


const Skills = () => {
  return (
    <section className="skills section" id="skills">
      <h2 className="section_title">Skills</h2>
      <span className="section_subtitle">My techincal skills</span>

      <div className="skills_container container grid">
        <Android />
        <CrossPlatform />
        <Languages />
        <Others />
        {/* <MachineLearning /> */}
        <UxUi />
      </div>
    </section>
  );
};

export default Skills;
